import React from 'react';
import { motion } from 'framer-motion';
const pillars = [{
  title: 'Kvalitet',
  description: 'Råvaror vi tror på, hantverk vi står för.',
  icon: '◆'
}, {
  title: 'Kreativitet',
  description: 'Klassiska smaker möter nya idéer.',
  icon: '◆'
}, {
  title: 'Passion',
  description: 'Vi älskar det vi gör – varje dag.',
  icon: '◆'
}, {
  title: 'Hantverk',
  description: 'Allt bakas från grunden, med tid och omsorg.',
  icon: '◆'
}];
export function Pillars() {
  return <section className="w-full py-20 md:py-28 px-4" data-id="element-820">
      <div className="max-w-5xl mx-auto" data-id="element-821">
        <motion.p initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center text-sm tracking-[0.2em] uppercase text-[#7C8062] font-medium mb-4" data-id="element-822">
          Vad vi står för
        </motion.p>
        <motion.h2 initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-center text-3xl md:text-4xl font-serif text-[#1A1A1A] mb-16 md:mb-20" data-id="element-823">
          Dag in och dag ut
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-6" data-id="element-824">
          {pillars.map((pillar, index) => <motion.div key={pillar.title} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.12
        }} className="flex flex-col items-center text-center" data-id="element-825">
              <div className="w-12 h-12 rounded-full bg-[#7C8062]/10 border border-[#7C8062]/20 flex items-center justify-center mb-5" data-id="element-826">
                <span className="text-[#7C8062] text-sm" data-id="element-827">{pillar.icon}</span>
              </div>
              <h3 className="text-xl font-serif text-[#1A1A1A] mb-3" data-id="element-828">
                {pillar.title}
              </h3>
              <div className="w-8 h-px bg-[#7C8062]/30 mb-3" data-id="element-829" />
              <p className="text-[#1A1A1A]/60 text-sm leading-relaxed max-w-[200px]" data-id="element-830">
                {pillar.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}